var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1470.5 335.3",
    style: {
      enableBackground: "new 0 0 1470.5 335.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF3C33;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 4.9,
    className: "st0",
    width: 590.6,
    height: 326.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 146.2,
    className: "st1",
    width: 52.2,
    height: 52.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.8,238.8 43.2,289.9 102.3,289.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.2,
    y: 146.2,
    className: "st1",
    width: 177.3,
    height: 52.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.2,
    y: 238.3,
    className: "st1",
    width: 107,
    height: 52.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.1,7.9h26.2v44.4h50.9V7.9h26.2v119h-26.2V75.4h-50.9v51.4h-26.2V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M760.2,7.9h26.2v119h-26.2V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M810.3,7.9h46c6,0,11.8,0.6,17.2,1.8s10.2,3.1,14.3,5.9c4.1,2.7,7.3,6.4,9.7,11.1c2.4,4.6,3.6,10.4,3.6,17.4 c0,8.4-2.2,15.5-6.6,21.4c-4.4,5.9-10.8,9.6-19.2,11.2l30.2,50.2h-31.4l-24.9-47.6h-12.9v47.6h-26.2V7.9z M836.5,57.1H852 c2.4,0,4.8-0.1,7.5-0.3c2.6-0.2,5-0.7,7.1-1.5c2.1-0.8,3.9-2.2,5.3-3.9c1.4-1.8,2.1-4.3,2.1-7.6c0-3-0.6-5.4-1.8-7.2 c-1.2-1.8-2.8-3.2-4.7-4.1c-1.9-1-4.1-1.6-6.6-1.9c-2.5-0.3-4.9-0.5-7.2-0.5h-17.1V57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M912.8,67.4c0-9.5,1.6-18.1,4.8-25.9s7.6-14.3,13.4-19.7c5.7-5.4,12.5-9.6,20.3-12.5 c7.8-2.9,16.4-4.4,25.7-4.4s17.9,1.5,25.7,4.4c7.8,2.9,14.6,7.1,20.3,12.5c5.7,5.4,10.2,12,13.4,19.7c3.2,7.7,4.8,16.4,4.8,25.9 c0,9.5-1.6,18.1-4.8,25.9c-3.2,7.7-7.6,14.3-13.4,19.7c-5.7,5.4-12.5,9.6-20.3,12.5c-7.8,2.9-16.4,4.4-25.7,4.4 s-17.9-1.5-25.7-4.4c-7.8-2.9-14.6-7.1-20.3-12.5c-5.7-5.4-10.2-12-13.4-19.7S912.8,76.9,912.8,67.4z M940,67.4 c0,5.6,0.9,10.7,2.6,15.4c1.7,4.6,4.2,8.7,7.5,12.1s7.1,6.1,11.7,8c4.5,1.9,9.6,2.9,15.2,2.9c5.6,0,10.7-0.9,15.2-2.9 c4.5-1.9,8.4-4.6,11.7-8s5.7-7.4,7.5-12.1c1.7-4.6,2.6-9.8,2.6-15.4c0-5.5-0.9-10.6-2.6-15.3c-1.7-4.7-4.2-8.8-7.5-12.2 c-3.2-3.4-7.1-6.1-11.7-8c-4.5-1.9-9.6-2.9-15.2-2.9c-5.6,0-10.7,1-15.2,2.9c-4.5,1.9-8.4,4.6-11.7,8c-3.2,3.4-5.7,7.5-7.5,12.2 C940.9,56.8,940,61.9,940,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1059,7.9h35.6l50.6,82.7h0.3V7.9h26.2v119h-34.3l-51.9-84.7h-0.3v84.7H1059V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1189.5,67.4c0-9.5,1.6-18.1,4.8-25.9s7.6-14.3,13.4-19.7s12.5-9.6,20.3-12.5c7.8-2.9,16.4-4.4,25.7-4.4 s17.9,1.5,25.7,4.4c7.8,2.9,14.6,7.1,20.3,12.5c5.7,5.4,10.2,12,13.4,19.7c3.2,7.7,4.8,16.4,4.8,25.9c0,9.5-1.6,18.1-4.8,25.9 c-3.2,7.7-7.6,14.3-13.4,19.7c-5.7,5.4-12.5,9.6-20.3,12.5c-7.8,2.9-16.4,4.4-25.7,4.4s-17.9-1.5-25.7-4.4 c-7.8-2.9-14.6-7.1-20.3-12.5c-5.7-5.4-10.2-12-13.4-19.7S1189.5,76.9,1189.5,67.4z M1216.8,67.4c0,5.6,0.9,10.7,2.6,15.4 c1.7,4.6,4.2,8.7,7.5,12.1s7.1,6.1,11.7,8c4.5,1.9,9.6,2.9,15.2,2.9s10.7-0.9,15.2-2.9c4.5-1.9,8.4-4.6,11.7-8s5.7-7.4,7.5-12.1 c1.7-4.6,2.6-9.8,2.6-15.4c0-5.5-0.9-10.6-2.6-15.3c-1.7-4.7-4.2-8.8-7.5-12.2c-3.2-3.4-7.1-6.1-11.7-8c-4.5-1.9-9.6-2.9-15.2-2.9 s-10.7,1-15.2,2.9c-4.5,1.9-8.4,4.6-11.7,8c-3.2,3.4-5.7,7.5-7.5,12.2C1217.6,56.8,1216.8,61.9,1216.8,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1335.7,7.9h46c6,0,11.8,0.6,17.2,1.8c5.4,1.2,10.2,3.1,14.3,5.9c4.1,2.7,7.3,6.4,9.7,11.1 c2.4,4.6,3.6,10.4,3.6,17.4c0,8.4-2.2,15.5-6.6,21.4c-4.4,5.9-10.8,9.6-19.2,11.2l30.2,50.2h-31.4l-24.9-47.6h-12.9v47.6h-26.2 V7.9z M1361.9,57.1h15.5c2.4,0,4.8-0.1,7.5-0.3c2.6-0.2,5-0.7,7.1-1.5c2.1-0.8,3.9-2.2,5.3-3.9c1.4-1.8,2.1-4.3,2.1-7.6 c0-3-0.6-5.4-1.8-7.2c-1.2-1.8-2.8-3.2-4.7-4.1c-1.9-1-4.1-1.6-6.6-1.9c-2.5-0.3-4.9-0.5-7.2-0.5h-17.1V57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1444.3,7.9h26.2v119h-26.2V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M672.2,209.5h21.7l51.8,119h-29.6l-10.2-25.2h-46.2l-9.9,25.2h-28.9L672.2,209.5z M682.3,244.1l-14.5,37h29.1 L682.3,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M757.2,209.5h26.2v119h-26.2V209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M807.3,209.5h26.2v44.4h50.9v-44.4h26.2v119h-26.2v-51.4h-50.9v51.4h-26.2V209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M974,209.5h21.7l51.8,119h-29.6l-10.2-25.2h-46.2l-9.9,25.2h-28.9L974,209.5z M984.1,244.1l-14.5,37h29.1 L984.1,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1059.3,209.5h46c6,0,11.8,0.6,17.2,1.8c5.4,1.2,10.2,3.1,14.3,5.9c4.1,2.7,7.3,6.4,9.7,11.1 c2.4,4.6,3.6,10.4,3.6,17.4c0,8.4-2.2,15.5-6.6,21.4c-4.4,5.9-10.8,9.6-19.2,11.2l30.2,50.2h-31.4l-24.9-47.6h-12.9v47.6h-26.2 V209.5z M1085.5,258.8h15.5c2.4,0,4.8-0.1,7.5-0.3c2.6-0.2,5-0.7,7.1-1.5c2.1-0.8,3.9-2.2,5.3-3.9c1.4-1.8,2.1-4.3,2.1-7.6 c0-3-0.6-5.4-1.8-7.2c-1.2-1.8-2.8-3.2-4.7-4.1c-1.9-1-4.1-1.6-6.6-1.9c-2.5-0.3-4.9-0.5-7.2-0.5h-17.1V258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1207.4,209.5h21.7l51.8,119h-29.6l-10.2-25.2h-46.2l-9.9,25.2h-28.9L1207.4,209.5z M1217.4,244.1l-14.5,37 h29.1L1217.4,244.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.1d4206009756e7f5ac43dbbe150d95d0.svg";
export { ForwardRef as ReactComponent };